import React, { FC } from 'react';

interface ITagIconProps {
  className?: string;
  size?: number | string;
}

const TagIcon: FC<ITagIconProps> = ({ className, size = '100%' }) => (
  <svg width={size} height={size} viewBox="0 0 18 18" className={className}>
    <g fill="none" fillRule="evenodd" transform="rotate(45 8.925 14.718)">
      <path
        stroke="currentColor"
        d="M1.124 5.195a.5.5 0 0 0-.124.33V16a.5.5 0 0 0 .5.5h7A.5.5 0 0 0 9 16V5.524a.5.5 0 0 0-.124-.329l-3.5-4.004a.5.5 0 0 0-.752 0l-3.5 4.004z"
      />
      <circle cx="4.793" cy="4.793" r="1.073" fill="currentColor" />
    </g>
  </svg>
);

export default TagIcon;
